// Import Swiper and modules
import Swiper, { Navigation, Pagination, EffectFade, Autoplay, Thumbs, Scrollbar, Grid } from 'swiper';

// Install modules
Swiper.use([Navigation, Pagination, EffectFade, Autoplay, Thumbs, Scrollbar, Grid]);

export function initSwiper() {
	const initSwiper = document.querySelectorAll('[data-swiper]');
	initSwiper.forEach((element) => {
		let params = JSON.parse(element.dataset.swiper);
		new Swiper(element, params);
	});
}

export function galleryWithThumbnails() {
	var galleryThumbs = new Swiper(".gallery-thumbs", {
		slidesPerView: 3,
		freeMode: true,
		watchSlidesProgress: true,
		direction: 'vertical',
		spaceBetween: 24,
		breakpoints: {
			// when window width is >= 320px
			320: {
				direction: 'horizontal',
				slidesPerView: 2,
			},
			// when window width is >= 768px
			768:{
				slidesPerView: 3,
				direction: 'horizontal',
			},
			// when window width is >= 1200px
			1200: {
				direction: 'vertical',
			}
		  }
	  });
	  
	  var galleryMain = new Swiper(".gallery-main", {
		navigation: {
		  nextEl: '.swiper-button-next',
		  prevEl: '.swiper-button-prev',
		},
		effect: 'fade',
		  fadeEffect: {
		  crossFade: true
		},
		thumbs: {
		  swiper: galleryThumbs,
		  autoScrollOffset: 1
		}
	  });
	  
	  const galleryMainElm = $('.gallery-main');

	  galleryMain.on('transitionEnd', function() {
		const endSlideIndex = galleryMain.slides.length - 1;
		if(galleryMain.activeIndex > 0 && galleryMain.activeIndex < endSlideIndex)
			galleryMainElm.find('.swiper-button-disabled').removeClass('swiper-button-disabled');
	  });
}

export function caseStudiesSlider() {
	if($('.marker-case-study-slider').length < 1) return

	$('.case-studies-slider__tab').on('click', function(e) {
		e.preventDefault();

		const self = $(this);
		const slider = $(this).closest('.case-studies-slider');

		slider.find('.open').removeClass('open');
		slider.find('.active').hide().removeClass('active');
		
		self.closest('.case-studies-slider__tab-container').addClass('open');
		self.parent().next().find('.case-studies-slider__content').addClass('active').fadeIn();
	});

}
